import { render, staticRenderFns } from "./CustomersCreateDialogFormCard.vue?vue&type=template&id=e6d09bb0&"
import script from "./CustomersCreateDialogFormCard.vue?vue&type=script&lang=ts&"
export * from "./CustomersCreateDialogFormCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports